// extracted by mini-css-extract-plugin
module.exports = {"links":"style_links__lAtSD","link":"style_link__2THJb","menu":"style_menu__KF39p","item":"style_item__esJqv","messageNotification":"style_messageNotification__3NNyZ"};